<template>
  <ul class="f-accordion">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'f-accordion',
  data() {
    return {
    };
  }
};
</script>
